import Image from 'next/image';
import { assetPrefix } from '@/lib/constants';

type CustomImageProps = Omit<React.ComponentProps<typeof Image>, 'src'> & {
  src: string;
};

export default function CustomImage({ src, ...rest }: CustomImageProps) {
  return <Image src={assetPrefix + src} loading="eager" {...rest} />;
}
